import { render, staticRenderFns } from "./dog-purchase-transaction-success.vue?vue&type=template&id=a9f5c9b4&scoped=true&lang=pug"
import script from "./dog-purchase-transaction-success.js?vue&type=script&lang=js&external"
export * from "./dog-purchase-transaction-success.js?vue&type=script&lang=js&external"
import style0 from "./dog-purchase-transaction-success.vue?vue&type=style&index=0&id=a9f5c9b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f5c9b4",
  null
  
)

export default component.exports